import { Link } from "react-router-dom";
import GlassNav from "@/components/layout/GlassNav";

// v23: correo de contacto (consultas y ejercicio de derechos sobre los datos) mientras los textos son provisionales.
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || "";

const DOCS = {
  aviso: {
    title: "Aviso legal",
    body: [
      "Este es un texto provisional pendiente de revisión legal.",
      "CaptAcción es un servicio de software para la prospección orgánica en redes sociales. El titular del sitio y sus datos identificativos se publicarán aquí tras la revisión jurídica correspondiente.",
      "El uso de la plataforma implica la aceptación de las condiciones que se detallarán en este documento una vez aprobado por asesoría legal.",
    ],
  },
  privacidad: {
    title: "Política de privacidad",
    body: [
      "Este es un texto provisional pendiente de revisión legal.",
      "Tratamos los datos estrictamente necesarios para prestar el servicio (cuenta, negocio y prospectos). No vendemos tus datos a terceros.",
      "El detalle de responsable, finalidades, base jurídica, conservación y derechos (acceso, rectificación, supresión) se publicará aquí tras la revisión legal.",
    ],
  },
  cookies: {
    title: "Política de cookies",
    body: [
      "Este es un texto provisional pendiente de revisión legal.",
      "CaptAcción solo usa almacenamiento técnico imprescindible para que funcione el servicio (mantener tu sesión iniciada). No usamos cookies de publicidad ni de analítica de terceros.",
      "Si en el futuro añadimos cookies no imprescindibles, te pediremos tu consentimiento antes de activarlas.",
    ],
  },
  terminos: {
    title: "Términos y condiciones",
    body: [
      "Este es un texto provisional pendiente de revisión legal.",
      "Al usar CaptAcción aceptas utilizar la herramienta de forma responsable y conforme a las normas de las plataformas conectadas. El envío de mensajes es siempre manual y bajo tu criterio.",
      "Las condiciones de suscripción, facturación y cancelación se detallarán aquí tras la revisión legal.",
    ],
  },
};

export default function Legal({ doc = "aviso" }) {
  const d = DOCS[doc] || DOCS.aviso;
  return (
    <div style={{ minHeight: "100vh", background: "var(--ca-ink)" }}>
      <GlassNav />
      <main className="container" style={{ maxWidth: 760, margin: "0 auto", padding: "140px 24px 100px" }}>
        <span className="ca-eyebrow">Legal</span>
        <h1 className="ca-serif" style={{ fontSize: "clamp(36px,5vw,52px)", margin: "14px 0 10px", color: "var(--ca-text)" }}>{d.title}</h1>
        <div style={{ display: "inline-block", padding: "6px 12px", borderRadius: 999, border: "1px solid var(--ca-line-2)", color: "var(--ca-gold)", fontFamily: "var(--ca-f-mono)", fontSize: 11, letterSpacing: ".1em", marginBottom: 28 }}>
          PENDIENTE DE REVISIÓN LEGAL
        </div>
        {d.body.map((p, i) => (
          <p key={i} style={{ color: "var(--ca-muted)", fontSize: 16, lineHeight: 1.7, marginBottom: 18 }}>{p}</p>
        ))}
        {SUPPORT_EMAIL && (
          <p data-testid="legal-contact" style={{ color: "var(--ca-muted)", fontSize: 16, lineHeight: 1.7, marginBottom: 18 }}>
            Para cualquier consulta, o para pedir el acceso, la corrección o la eliminación de tus datos, escríbenos a{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: "var(--ca-gold)", fontWeight: 600 }}>{SUPPORT_EMAIL}</a>.
          </p>
        )}
        <Link to="/" style={{ display: "inline-block", marginTop: 24, color: "var(--ca-gold)", fontWeight: 600 }}>← Volver a la portada</Link>
      </main>
    </div>
  );
}
